import $ from 'jquery'
import SimpleTooltip from './SimpleTooltip'

class SimpleSingletonTooltip extends SimpleTooltip {
    constructor() {
        super({extraClass: 'simpleSingletonTooltip'})

        this.state = {
            text: '',
            html: '',
            extraClass: '',
        }

        /*
        * There are two incompatible properties in state - text and html.
        * Only one property affect to representation at the moment.
        * Think about refactoring
        * */
        this.onStatePropertyChanged('text', text => {
            if (text) {
                this.state.html = ''
                this.setText(text)
            }
        })

        this.onStatePropertyChanged('html', html => {
            if (html) {
                this.state.text = ''
                this.setHtml(html)
            }
        })

        this.onStatePropertyChanged('extraClass', (newExtraClass, oldExtraClass) => {
            this.$el.removeClass(oldExtraClass)
            this.$el.addClass(newExtraClass)
        })

        this.stateStack = []
    }

    show() {
        super.show()
        this.stateStack.push(this.state)
    }

    hide() {
        this.stateStack.pop()
        if (this.stateStack.length === 0) {
            super.hide()
        } else {
            this.setState(this.stateStack[this.stateStack.length - 1])
        }
    }
}

let instance = null
export const getInstance = () => {
    if (instance === null) {
        instance = new SimpleSingletonTooltip().init($('body'))
    }
    return instance
}

export default function tooltip($el, state) {
    getInstance().subscribeToMouseEvents($el, () => getInstance().setState(state))
}


// WEBPACK FOOTER //
// ./web/js/SimpleSingletonTooltip.js